export const OUT_OF_PUS_RESTRICTION = 'OUT_OF_PUS';

export enum RoleLevel {
  ORGANIZATION_USER = 100,
  ORGANIZATION_ADMIN = 1000,
  PLANET_USER = 1999,
  PLANET_ADMIN = 2000,
}
